/**
 * Barrel do módulo FinOps.
 *
 * Existe para o `router.tsx` importar de UM lugar só e não precisar conhecer a
 * organização interna de `telas/`. As telas em si vivem em arquivos separados,
 * porque a `2e` e a `2c` são grandes demais para dividirem arquivo com nada.
 *
 * `ResultadoAcumulado` (`2h`) NÃO é exportada aqui de propósito: ela não é rota.
 * É uma sub-visão aberta por botão dentro do Dashboard, decidido em 2026-08-12,
 * e exportá-la aqui convidaria alguém a lhe dar uma URL.
 */
import { lazy } from 'react'

export { ConfiguracoesFinops } from './telas/ConfiguracoesFinops'
export { Discovery } from './telas/Discovery'
export { OportunidadeFormulario } from './telas/OportunidadeFormulario'
export { Oportunidades } from './telas/Oportunidades'

/**
 * ⚠️ As duas telas COM GRÁFICO entram por `lazy`, e o resto não.
 *
 * O Recharts é a maior peça nova do bundle deste módulo, e ninguém aterrissa
 * primeiro no Cost Explorer: o caminho normal é login → seletor de cliente →
 * uma aba. Carregar a biblioteca de gráficos no chunk inicial faria todo mundo
 * pagar por ela — inclusive quem só usa a grade de Oportunidades.
 *
 * `ResultadoAcumulado` (`2h`) é importada por `DashboardPublicado` e entra no
 * mesmo chunk, o que é desejável: quem abre o dashboard costuma abrir o modal.
 */
export const CostExplorer = lazy(() =>
  import('./telas/CostExplorer').then((m) => ({ default: m.CostExplorer })),
)
export const DashboardPublicado = lazy(() =>
  import('./telas/DashboardPublicado').then((m) => ({ default: m.DashboardPublicado })),
)
